export function getDataByBundle(data: any) {

  const {
    user_id,
    username: username_raw,
    name,
    email,
    phoneNo,
    instagram_link,
    youtube_link,
    amazon_link,
    podcast_link,
    pinterest_link,
    pinterest_user,
    twitter_link,
    newsletter_email,
    instagram_links,
    is_onboarding_finished,
    is_nec_search,
    avg_caption_words,
    is_instagram_on,
    is_youtube_on,
    is_newsletter_on,
    is_tiktok_on,
    is_twitter_on,
    is_podcast_on,
    is_pinterest_on,
    is_linkedin_on,
    is_nec_present,
    first_connected_platform,
    subscription_type,
    social_instagram,
    social_youtube,
    social_tiktok,
    social_twitter,
    social_podcast,
    social_pinterest,
    social_linkedin,
    social_website,
    social_newsletter,
    social_facebook,
    social_amazon,
    social_shopmy,
    social_shop,
    social_ltk,
    social_affiliate_amazon,
    social_affiliate_shopmy,
    social_affiliate_ltk,
    social_spotify,
    social_applepodcast,
    social_discord,
    social_snapchat,
    storage_url,
    picture,
    original_profile_url,
    image_crop,
    email_verify,
    description,
    search_bar_text: search_bar_text_raw,
    search_bar_tags,
    brand_color,
    brand_text_color,
    social_links_order,
    is_flowdesk_on,
    flowdesk_user,
    is_flowdeskpopup_on,
    flowdeskpopup_user,
    is_fillout_on,
    fillout_user,
    phone_code,
    payment_status,
    payment_plan,
    show_amazon,
    show_ltk,
    show_shopmy,
    show_mystore,
    is_embed_search,
    embed_configure,
    is_first_redirect,
    is_first_login,
    is_page_ready,
    platforms_status,
    platforms_data,
    active_campaign,
    show_add_member,
    team_members,
    stripe_detail,
    display_name,
    design_feature,
    template_name,
    design_template_index,
    font_family,
    background_style,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    show_contact_page,
    embed_carousel_website,
    show_expiration,
    show_collection,
    show_pinned,
    social_custom,
    multi_page_feature,
    domain,
    url_type,
    browsable_template_editing_started_at,
    browsable_website_published_at,
    website_demo,
    blog_feature,
  } = data;

  // Prefer storage_url over picture if present
  const pictureUrl = storage_url || picture || null;

  // Pinterest: handle either field (some places used pinterest_user)
  const resolvedPinterest = pinterest_link ?? pinterest_user ?? null;

//   Build social link list once
  const socialLinks = [
    { term: "instagram", link: instagram_link },
    { term: "youtube", link: youtube_link },
    { term: "amazon", link: amazon_link },
    { term: "podcast", link: podcast_link },
    { term: "pinterest", link: pinterest_link },
    { term: "twitter", link: twitter_link },
    { term: "newsletter", link: newsletter_email },
  ];
  const activeSocials = socialLinks.filter(s => s.link).map(({ term, link }) => ({ term, link }));

  const showSocials = [
    { platform: "instagram", isOn: is_instagram_on },
    { platform: "youtube", isOn: is_youtube_on },
    { platform: "podcast", isOn: is_podcast_on },
    { platform: "newsletter", isOn: is_newsletter_on },
    { platform: "tiktok", isOn: is_tiktok_on },
    { platform: "twitter", isOn: is_twitter_on },
    { platform: "linkedin", isOn: is_linkedin_on },
    { platform: "pinterest", isOn: is_pinterest_on },
    // always-on virtual groups you used before:
    { platform: "LTK", isOn: true },
    { platform: "Amazon", isOn: true },
    { platform: "ShopMy", isOn: true },
    { platform: "MISC", isOn: true },
    { platform: "MISC-content", isOn: true },
  ]
    .filter((s) => s.isOn)
    .map((s) => s.platform);

  const resolvedSearchBarText =
    search_bar_text_raw && search_bar_text_raw.trim().length > 0
      ? search_bar_text_raw
      : name
      ? `Search ${name} Content`
      : "Search";

  const userExists = !!subscription_type;
  const designTokens = {
    fontFamily: font_family,
    primaryColor: background_style || "",
    secondaryColor:button_background || "#e6e7eb",
    tertiaryColor:button_text || "",
    templateName:template_name,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    template_name,
    font_family,
    background_style,
  };

  // Side effect parity: keep old behavior if needed
  if (email_verify === false) {
    try {
      localStorage.setItem("email_verify", "false");
    } catch {}
  }

  // ----- Unified return shape (superset of both old functions) -----
  return {
    // Not-found marker
    userNotFound: false,

    // Common IDs
    user_id,
    username:
      typeof username_raw === "string" && username_raw.trim()
        ? username_raw.trim()
        : typeof (data as { username?: string })?.username === "string"
          ? String((data as { username?: string }).username).trim()
          : "",
    userExists,
    designTokens,
    // Identity
    name,
    display_name,
    email,
    phoneNo,
    phone_code,

    // Pictures
    picture, // raw DB picture
    pictureUrl, // preferred (storage_url || picture)
    original_profile_url: original_profile_url || null, // uncropped source for Crop & Zoom restore
    image_crop: image_crop || null, // persisted crop restore payload

    // Social links (individual)
    instaLink: instagram_link ?? null,
    youtubeLink: youtube_link ?? null,
    amazonLink: amazon_link ?? null,
    podcastLink: podcast_link ?? null,
    pinterestLink: resolvedPinterest,
    twitterLink: twitter_link ?? null,
    newsletterLink: newsletter_email ?? null,

    // Aggregated socials
    activeSocials,
    showSocials,

    // Booleans & feature flags
    isOnboardingFinished: is_onboarding_finished,
    isNecSearch: is_nec_search,
    is_nec_present,
    first_connected_platform,
    isInstagram: is_instagram_on,
    isYoutube: is_youtube_on,
    isNewsletter: is_newsletter_on,
    isTiktok: is_tiktok_on,
    isTwitter: is_twitter_on,
    isPodcast: is_podcast_on,
    isPinterest: is_pinterest_on,
    isLinkedin: is_linkedin_on,
    is_embed_search,
    embed_configure,
    is_first_redirect,
    is_first_login,
    is_page_ready,
    email_verify,

    // Content & UI
    description,
    search_bar_text: resolvedSearchBarText,
    search_bar_tags,
    brand_color,
    brand_text_color,
    social_links_order,
    instagram_links,

    // Third-party integrations
    is_flowdesk_on,
    flowdeskId: flowdesk_user,
    is_flowdeskpopup_on,
    flowdeskPopupId: flowdeskpopup_user,
    is_fillout_on,
    filloutId: fillout_user,

    // Payments & team
    payment_status,
    payment_plan,
    subscription_type,
    show_amazon,
    show_ltk,
    show_shopmy,
    show_mystore,
    active_campaign,
    show_add_member,
    team_members,
    stripe_detail,
    design_feature,

    // Platforms + misc
    platforms_status,
    platforms_data,

    // Analytics / derived
    avg_words: avg_caption_words,
    social_instagram,
    social_youtube,
    social_tiktok,
    social_twitter,
    social_podcast,
    social_pinterest,
    social_linkedin,
    social_website,
    social_newsletter,
    social_facebook,
    social_amazon,
    social_shopmy,
    social_shop,
    social_ltk,
    social_affiliate_amazon,
    social_affiliate_shopmy,
    social_affiliate_ltk,
    social_spotify,
    social_applepodcast,
    social_discord,
    social_snapchat,
    template_name,
    design_template_index,
    font_family,
    background_style,
    button_background,
    button_text,
    button_border,
    text_color,
    social_icon_color,
    show_contact_page,
    embed_carousel_website,
    show_expiration,
    show_collection,
    show_pinned,
    social_custom,
    multi_page_feature,
    domain,
    url_type,
    browsable_template_editing_started_at: browsable_template_editing_started_at ?? null,
    browsable_website_published_at: browsable_website_published_at ?? null,
    /** Admin Website Demo — editor + /website/:user; LiB stays at /:user. */
    website_demo: Boolean(website_demo),
    /** Engineering Controls — Blog sidebar + Content Bank Generate. */
    blog_feature: Boolean(blog_feature),
  };
}
